import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLLight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 320 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M48 32c8.8 0 16 7.2 16 16l0 400 240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16L32 48c0-8.8 7.2-16 16-16z" })
});
export default SvgLLight;
